/**
 * UserAction enum to match backend com.medprompt.metadata.UserAction
 * Represents the types of actions by users that are tracked
 */
export const UserAction = {
  CREATE: 'CREATE',
  OPEN: 'OPEN',
  EDIT: 'EDIT',
  COMPLETE_RECORDING: 'COMPLETE_RECORDING',
  REGENERATE: 'REGENERATE',
  COMMUNICATE: 'COMMUNICATE',
  FILE_AWAY: 'FILE_AWAY',
  COMPLETE: 'COMPLETE',
  DELETE: 'DELETE',
};

/**
 * Human-readable labels for each user action
 */
export const UserActionLabels = {
  CREATE: 'Uploaded',
  OPEN: 'Opened',
  EDIT: 'Edited',
  COMPLETE_RECORDING: 'Completed Recording',
  REGENERATE: 'Regenerated',
  COMMUNICATE: 'Communicated with Patient',
  FILE_AWAY: 'Filed Away',
  COMPLETE: 'Marked Complete',
  DELETE: 'Deleted',
};

/**
 * Color mapping for each user action in charts
 */
export const UserActionColors = {
  CREATE: '#3498db',
  OPEN: '#82ca9d',
  EDIT: '#0088FE',
  COMPLETE_RECORDING: '#16a085',
  REGENERATE: '#00C49F',
  COMMUNICATE: '#9b59b6',
  FILE_AWAY: '#FFBB28',
  COMPLETE: '#2ecc71',
  DELETE: '#FF8042',
};

/**
 * Action verb mapping for activity descriptions
 * Used in activity modals and audit logs
 */
export const UserActionVerbs = {
  CREATE: 'uploaded',
  OPEN: 'opened',
  EDIT: 'edited',
  COMPLETE_RECORDING: 'completed recording',
  REGENERATE: 'regenerated',
  COMMUNICATE: 'communicated with patient',
  FILE_AWAY: 'filed away',
  COMPLETE: 'marked complete',
  DELETE: 'deleted',
};

/**
 * Document-specific actions (matches backend documentActions())
 */
export const DOCUMENT_ACTIONS = [
  UserAction.CREATE,
  UserAction.OPEN,
  UserAction.EDIT,
  UserAction.REGENERATE,
  UserAction.COMMUNICATE,
  UserAction.FILE_AWAY,
  UserAction.DELETE,
];

/**
 * Consultation-specific actions (matches backend consultationActions())
 */
export const CONSULTATION_ACTIONS = [
  UserAction.CREATE,
  UserAction.OPEN,
  UserAction.EDIT,
  UserAction.COMPLETE_RECORDING,
  UserAction.REGENERATE,
  UserAction.COMMUNICATE,
  UserAction.FILE_AWAY,
  UserAction.DELETE,
];

/**
 * Task-specific actions (matches backend taskActions())
 */
export const TASK_ACTIONS = [
  UserAction.OPEN,
  UserAction.EDIT,
  UserAction.COMPLETE,
  UserAction.DELETE,
];
